export const BASE_URL = 'https://mirror-transport.mirror.edunixsystem.com'
// export const BASE_URL = 'https://transport-api.motherland.edunixsystem.com'
// export const BASE_URL = 'https://bus-api.alnukhbeh-edu.com'
// export const BASE_URL = 'https://bus-api.rowadalmustakbal.edunixsystem.com'
// export const BASE_URL = 'https://transport-api.albayan-schools.com'
// export const BASE_URL = 'https://api.albayan-schools.com'